import { createFileRoute } from '@tanstack/react-router'
import { GlobeIcon, LayersIcon } from 'lucide-react'
import { useEffect } from 'react'

import { useGetClientMarket } from '@/gen/publicApi/hooks'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError'

import { Card, CardContent } from '@/components/card'
import Content from '@/components/content'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'
import { useAddRecentMarket } from '@/state/recentMarkets'

import MarketConfig from '../-components/marketConfig'

import CreateMarketTemplateOption from './-components/createMarketTemplateOption'
import MarketHeading from './-components/marketHeading'
import MarketNavigation from './-components/marketNavigation'

export const Route = createFileRoute('/_authed/$client_code/markets/$market_code/')({
    component: MarketIndexComponent,
})

function MarketIndexComponent() {
    const { client_code, market_code } = Route.useParams()
    const setRecentMarket = useAddRecentMarket()
    const { data: market } = useGetClientMarket(client_code, market_code, { query: { suspense: true } })

    useSetBreadcrumbs([
        {
            to: '/$client_code/markets',
            text: 'Markets',
            params: { client_code },
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code',
            params: {
                market_code,
                client_code,
            },
            text: market?.name || '--',
        },
    ])

    useEffect(() => {
        setRecentMarket(client_code, market_code)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!market) {
        return <UnexpectedDataStateError />
    }

    const isTemplate = market.marketType === 'Template'

    return (
        <>
            <MarketHeading market={market} />
            <Content>
                <MarketNavigation active="details" isTemplate={isTemplate}>
                    {!isTemplate && <CreateMarketTemplateOption marketCode={market_code} />}
                </MarketNavigation>

                <div className="grid grid-cols-3 gap-4">
                    <Card className="col-span-2">
                        <CardContent className="pt-6">
                            <p className="flex items-center">
                                <LayersIcon className="w-4 h-4 mr-2" />
                                {market.marketType}
                            </p>
                            <p className="flex items-center">
                                <GlobeIcon className="w-4 h-4 mr-2" />
                                {market.timezone}
                            </p>
                        </CardContent>
                    </Card>
                    <Card className="col-span-1">
                        <CardContent>
                            <MarketConfig market={market} />
                        </CardContent>
                    </Card>
                </div>
            </Content>
        </>
    )
}
